import styled from "styled-components";

import { convertPxToRem } from "frontend/components/helpers";

export const TooltipText = styled.p`
    display: block;
    margin-bottom: ${convertPxToRem({ px: 8 })};
`;
